import React, { FC } from 'react';

import cx from 'classnames';

import Text from 'components/shared/Typography/Text';

import styles from './index.module.css';
import { IInputErrorProps } from './types';

const InputError: FC<IInputErrorProps> = ({ error, className }) => {
  const errorClasses = cx('custom-input-error', styles.formError, className);

  return (
    <div className={errorClasses}>
      <Text type="danger" size="small" accent>
        {error}
      </Text>
    </div>
  );
};

export default InputError;
